interface Array<T> {
    IsNotNullOrEmpty(): boolean;
    IsNotNull(): boolean;
    IsNullOrEmpty(): boolean;
    firstOrDefault(): T;
    lastOrDefault(): T;
    clear(): void;
    add(o: T): void;
    addRange<T>(o: Array<T>, mapper?: (x: T) => T): void;
    addWithMap<TDes, TSource>(arr: Array<TSource>, mapper: (x: TSource) => TDes): void;
    addOrUpdate<T>(predicate: any, o: T, updateCallBack: any): void;
    remove<T>(predicate: (x: T) => boolean): void;
    removeRange<T>(items: Array<T>, predicate: any): void;
    sum<T>(predicate: (x: T) => number): number;
    exist<T>(predicate: (x: T) => boolean): boolean;
}

Array.prototype.IsNullOrEmpty = function <T>(): boolean {
    const self = this;
    return self == null || self.length == 0;
}

Array.prototype.IsNotNullOrEmpty = function <T>(): boolean {
    const self = this;
    return !!self && self.length > 0;
}

Array.prototype.IsNotNull = function <T>(): boolean {
    const self = this;
    return !!self;
}

Array.prototype.firstOrDefault = function () {
    const self = this;
    if (self.IsNotNullOrEmpty()) {
        return self[0];
    } else {
        return null;
    }
}

Array.prototype.lastOrDefault = function () {
    const self = this;
    if (self.IsNotNullOrEmpty()) {
        return self[self.length - 1];
    } else {
        return null;
    }
}

Array.prototype.clear = function () {
    const self = this;
    if (self.IsNotNullOrEmpty()) {
        self.length = 0;
    }
}

Array.prototype.addRange = function <T>(arr: Array<T>, mapper?: (x: T) => T) {
    let self = this;
    if (self == null) {
        self = [];
    }

    if (arr.IsNotNullOrEmpty()) {
        for (let i = 0; i < arr.length; i++) {
            if(!!mapper) {
                self.push(mapper(arr[i]));
            } else {
                self.push(arr[i]);
            }
        }
    }
}

Array.prototype.addWithMap = function <TDes, TSource>(arr: Array<TSource>, mapper: (x: TSource) => TDes) {
    let self = this;
    if (self == null) {
        self = [];
    }

    if (arr.IsNotNullOrEmpty()) {
        for (let i = 0; i < arr.length; i++) {
            const current = arr[i] as TSource;
            if (!current) continue;
            self.push(mapper(current));
        }
    }
}


Array.prototype.add = function <T>(o: T) {
    let self = this;
    if (self == null) {
        self = [];
    }
    self.push(o);
}

Array.prototype.addOrUpdate = function <T>(predicate: any, val: T, updateCallBack: any) {
    let self = this;
    if (self == null) {
        self = [];
    }

    if (self.IsNotNullOrEmpty()) {
        var indexOfItem = self.findIndex(x => predicate(x));
        if (indexOfItem != -1) {
            updateCallBack(self[indexOfItem], val);
            return;
        }
    }
    self.push(val);
}

Array.prototype.remove = function <T>(predicate: (x: T) => boolean) {
    const self = this;
    if (self.IsNotNullOrEmpty() && predicate != null) {
        var indexOfItem = self.findIndex(x => predicate(x));
        if (indexOfItem != -1) {
            self.splice(indexOfItem, 1);
        }
    }
}

Array.prototype.removeRange = function <T>(items: Array<T>, predicate: any) {
    const self = this;
    if (self.IsNotNullOrEmpty() && items.IsNotNullOrEmpty()) {
        items.forEach(el => {
            var indexOfItem = self.findIndex(x => predicate(x, el));
            if (indexOfItem != -1) {
                self.splice(indexOfItem, 1);
            }
        });
    }
}

Array.prototype.sum = function <T>(predicate: (x: T) => number): number {
    const self = this;
    if (self.IsNullOrEmpty()) return 0;
    let temp = 0;
    for (let index = 0; index < self.length; index++) {
        const itemCount = predicate(self[index]);
        if(!!itemCount && itemCount != 0) {
            temp += itemCount;
        }
    }
    return temp;
}

Array.prototype.exist = function <T>(predicate: (x: T) => boolean): boolean {
    const self = this;
    if (self.IsNullOrEmpty()) return false;
    return self.find(x => predicate(x)) != null;
}

// Array.prototype.update = function (predicate, callBack) {
//     const self = this;
//     if (self.IsNotNullOrEmpty()) {
//         var indexOfItem = self.findIndex(x => predicate(x));
//         if (indexOfItem != -1) {
//             callBack(self[indexOfItem]);
//         }
//     }
// }